import findLastIndex from './findLastIndex.js';
import createIndexFinder from './_createIndexFinder.js'; // Return the position of the last occurrence of an item in an array,
// or -1 if the item is not included in the array.

export default createIndexFinder(-1, findLastIndex);